export const numberFormatter = new Intl.NumberFormat("en-US");
export const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
});

export const formatParcelIndices = (indices: number[]): string => {
    const parcels = indices.map((index) => (index + 1).toString());
    return `${parcels.slice(0, -1).join(", ")} & ${parcels[parcels.length - 1]}`;
};
